export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14757.e13df5b8.jpg";